import Modal from '@/dsComponents/Modal';
import { ModalBody, ModalFooter, ModalFooterLeft, ModalFooterRight, ModalHeader, ModalTitle } from '@dextech-ai/dex-design-system';
import { ErrorOutlineOutlined } from '@dextech-ai/dex-design-system/icons';
import Button from '@/components/Button/index';

// DS Modal version of the legacy ModalTemplate (moved here from src/components). `icon` is the DS header icon (a DS icon element);
// the legacy shell couldn't be dismissed by a click outside it, so neither can this one.
const ModalTemplate = ({ visible, hide, icon, title, message, leftFooterAction, rightFooterAction, rightFooterButtonText, addClass }) => {

    return (
        <Modal visible={visible} close={hide} dismissClickOutsideModal={false} addClass={addClass}>
            <ModalHeader icon={icon ?? <ErrorOutlineOutlined color="error" />}>
                <ModalTitle>{title || "-"}</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <div>
                    {message ?? 'Error'}
                </div>
            </ModalBody>
            <ModalFooter>
                <ModalFooterLeft>
                    {leftFooterAction ?? <></>}
                </ModalFooterLeft>
                <ModalFooterRight>
                    {rightFooterAction ?? <Button data-testid="modal-template-confirm" full round maxWidth="100" submit={() => hide()} text={rightFooterButtonText || "Confirm"} />}
                </ModalFooterRight>
            </ModalFooter>
        </Modal>
    )
};

export default ModalTemplate;
